module.exports = __webpack_public_path__ + "img/1970East-005_WEB-min.2cfcb69b.jpg";